import { render, staticRenderFns } from "./ShopMppUserGrowth.vue?vue&type=template&id=54f9ab54&scoped=true"
import script from "./ShopMppUserGrowth.vue?vue&type=script&lang=js"
export * from "./ShopMppUserGrowth.vue?vue&type=script&lang=js"
import style0 from "./ShopMppUserGrowth.vue?vue&type=style&index=0&id=54f9ab54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9ab54",
  null
  
)

export default component.exports